import { Injectable } from '@angular/core';
import { Offer } from '../../models/offer/offer.model';
import { OfferCoverageDestinyOption } from '../../models/offer/offer-coverage-destiny-option.model';
import { OfferCoverageDestinyOptionValues } from '../../models/offer/offer-coverage-destiny-option-values.model';

@Injectable({
  providedIn: 'root'
})
export class OfferValidationService {

  constructor() { }

  validateCoverages(offer: Offer): boolean {
    let isValid = true;
    offer.coverages.forEach(coverage => {
      coverage.destinies.forEach(destiny => {
        destiny.options.forEach(option => {
          if (option.values) {
            option.values.forEach(value => {
              const result = this.validateOptionValue(offer.id, option, value);
              isValid = isValid && result;
            });
          }
        })
      })
    });
    return isValid;
  }

  private validateOptionValue(id: string, option: OfferCoverageDestinyOption, value: OfferCoverageDestinyOptionValues): boolean {
    if (value.value) {
      const optionType = option.type.toUpperCase();
      const valueType = (typeof value.value).toUpperCase();

      if (optionType !== valueType) {
        console.warn(`Błąd walidacji oferty ${id}. Typ w opcji ${option.code}: ${optionType}, typ wartości: ${valueType}`);
        return false;
      } else {
        return true;
      }
    }
    return true;
  }
}
